import React, { useState } from 'react';
import { Dialog, DialogContent } from '../components/ui/dialog';
import { X, Play } from 'lucide-react';
import siteConfig from '../data/siteConfig.json';

const VideoModal = ({ isOpen, onClose }) => {
  const videoUrl = siteConfig.cta.secondary.videoUrl;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent 
        className="sm:max-w-2xl bg-[#0B0620] border-white/10 p-0 overflow-hidden"
        data-testid="video-modal"
      >
        <div className="relative">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 z-10 p-2 rounded-full bg-black/50 text-white hover:bg-black/70 transition-colors"
            data-testid="video-modal-close"
          >
            <X size={20} />
          </button>
          
          {videoUrl ? (
            <div className="aspect-video">
              <iframe
                src={videoUrl}
                title="ROMIND Demo"
                className="w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          ) : (
            <div className="aspect-video flex flex-col items-center justify-center bg-gradient-to-b from-violet-900/20 to-transparent p-8">
              <div className="w-20 h-20 rounded-full bg-violet-500/20 flex items-center justify-center mb-6 neon-glow">
                <Play size={32} className="text-violet-400 ml-1" />
              </div>
              <h3 className="text-2xl font-semibold text-white mb-2">Demo Coming Soon</h3>
              <p className="text-slate-400 text-center max-w-md">
                We're preparing something special. Join the early access list to be the first to see ROMIND in action.
              </p>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export const useVideoModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  
  return { isOpen, openModal, closeModal, VideoModal };
};

export default VideoModal;
